import { useLocation } from 'react-router-dom';

const useQueryParam = (param) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    return params.get(param);
};

export default useQueryParam;